export default {
  actionButton: 'Register for a call',

  palmWelcomeHeadingOne: '声明',
  palmWelcomeHeadingTwo: 'A LIVING STATEMENT',
  palmWelcomeHeadingThree: 'ON SAADIYAT ISLAND',
  palmWelcomeContent:
    'AN ICONIC JAPANESE-INSPIRED RESIDENCE, DESIGNED BY WORLD-RENOWNED ARCHITECT KOICHI TAKADA, MAMSHA PALM IS A HOME THAT IMMEDIATELY SETS ITSELF APART.',

  palmStoryHeading: 'QUIET LUXURY LIVING ON SAADIYAT ISLAND IS UNVEILING SOON',
  palmStoryContent:
    'DESIGNED TO CONNECT NATURE AND ARCHITECTURE, EVERY ELEMENT OF MAMSHA PALM REFLECTS QUIET LUXURY—FROM THE GRAND LOBBY AND SERENE TEA ROOM TO ITS ENVIABLE LOCATION IN THE HEART OF SAADIYAT CULTURAL DISTRICT.',
  palmStoryExplore: 'EXPLORE THE DISTRICT',

  palmRegistrationHeading: 'BE THE FIRST TO KNOW MORE',
  palmRegistrationContent:
    'REGISTER TO SPEAK WITH OUR DEDICATED SALES MANAGERS ABOUT MAMSHA PALM, AND RECEIVE GUIDANCE ON SECURING YOUR DREAM PROPERTY.',

  firstName: 'First Name',
  lastName: 'Last Name',
  email: 'Email Address',
  phoneNumber: 'Phone Number',
  reasonToBuy: 'Reason To Buy',
  nationality: 'Nationality',
  residencyStatus: 'Residency Status',
  residencyStatusOptionResident: 'Resident',
  residencyStatusOptionNonResident: 'Non-resident',
  reasonBuyOptionInvestor: 'Invest',
  reasonBuyOptionHomeOwner: 'Live',
  recieveUpdates:
    'Yes, I would like to receive luxury property listings, bespoke advice, and market trend updates.',
  consentLabel: 'I consent to the',
  privacyPolicy: 'Privacy Policy',
  termsAndConditions: 'Terms of Use',
  consentLabelEnd: 'from Aldar',
  footerContactTitle: 'Contact us:',
  launchFooterContactTitle: 'SAY HELLO,',
  footerContactCallText: 'CALL',
  footerContactCallNumber: '800 ALDAR',
  footerContactNumber: '+971 2 810 6400',
  footerContactWebsite: 'Aldar.com',
  developedBy: 'Developed by Aldar Properties',
  successHeading: 'Thank you for signing up',
  successContent:
    "Our dedicated sales managers look forward to speaking with you. Please monitor your inbox for exclusive updates. Intrigued by what else Aldar has to offer? Discover other world-class communities within the heart of Abu Dhabi's Cultural District.",
  successButton: 'Discover more communities',
};
